export const GET_CLASS_REQUEST = "GET_CLASS_REQUEST"
export const GET_CLASS_SUCCESS = "GET_CLASS_SUCCESS"
export const GET_YEAR_REQUEST = "GET_YEAR_REQUEST"
export const GET_YEAR_SUCCESS = "GET_YEAR_SUCCESS"
export const GET_QUARTER_REQUEST = "GET_QUARTER_REQUEST"
export const GET_QUARTER_SUCCESS = "GET_QUARTER_SUCCESS"
export const GET_REBATES_REQUEST = "GET_REBATES_REQUEST"
export const GET_REBATES_SUCCESS = "GET_REBATES_SUCCESS"